import axios from 'axios';

// APIのベースURL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Axiosインスタンスの作成
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// クリニック関連のAPI
export const clinicApi = {
  // 都道府県別クリニック一覧取得
  getByPrefecture: async (prefecture: string) => {
    try {
      const response = await api.get(`/clinics/${prefecture}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching clinics:', error);
      throw error;
    }
  },
  
  // 全クリニック一覧取得
  getAll: async () => {
    try {
      const response = await api.get('/clinics');
      return response.data;
    } catch (error) {
      console.error('Error fetching all clinics:', error);
      throw error;
    }
  },
};

// 予約枠関連のAPI
export const slotApi = {
  // クリニック別予約枠一覧取得
  getByClinic: async (clinicId: string, date?: string) => {
    try {
      const url = date
        ? `/slots/${clinicId}?date=${date}`
        : `/slots/${clinicId}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching slots:', error);
      throw error;
    }
  },
};

// 予約関連のAPI
export interface ReservationFormData {
  clinicId: string;
  dateTime: {
    date: string;
    time: string;
  };
  personalInfo: {
    lastName: string;
    firstName: string;
    lastNameKana: string;
    firstNameKana: string;
    phone: string;
    email: string;
    request?: string;
  };
}

export const reservationApi = {
  // 予約登録
  create: async (data: ReservationFormData) => {
    try {
      const response = await api.post('/reservations', data);
      return response.data;
    } catch (error) {
      console.error('Error creating reservation:', error);
      throw error;
    }
  },
  
  // 予約詳細取得
  getById: async (id: string) => {
    try {
      const response = await api.get(`/reservations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reservation:', error);
      throw error;
    }
  },
  
  // 予約一覧取得
  getAll: async () => {
    try {
      const response = await api.get('/reservations/list');
      return response.data;
    } catch (error) {
      console.error('Error fetching all reservations:', error);
      throw error;
    }
  },
};

export default api;
